import { ListBuilderField } from '@monorepo/shared/componentsV2/fields/ListBuilderField';
import styled from 'styled-components';

export const StyledListBuilderField = styled(ListBuilderField)`
  & div.MuiInputBase-root {
    width: 100%;
  }
`;
